"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "log-container" };
const _hoisted_2 = { class: "log-generations" };
const _hoisted_3 = { class: "log-gen-title" };
const _hoisted_4 = { class: "log-gen-numbers" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 0,
    class: "label-additional"
};
const _hoisted_7 = { class: "panel log-panel" };
const _hoisted_8 = {
    id: "logpanel-scrollable",
    class: "panel-body"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "debugid" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_log_message_component = (0, vue_1.resolveComponent)("log-message-component");
    const _component_card_panel = (0, vue_1.resolveComponent)("card-panel");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("h2", {
                class: (0, vue_1.normalizeClass)(_ctx.getTitleClasses())
            }, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[1] || (_cache[1] = [
                        (0, vue_1.createTextVNode)("Game log", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ], 2),
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                    (0, vue_1.createTextVNode)("Gen: ", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getGenerationsRange(), (n) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        key: n,
                        class: (0, vue_1.normalizeClass)(_ctx.getClassesGenIndicator(n)),
                        onClick: (0, vue_1.withModifiers)(($event) => (_ctx.selectGeneration(n)), ["prevent"])
                    }, (0, vue_1.toDisplayString)(n), 11, _hoisted_5));
                }), 128))
            ]),
            (_ctx.players.length === 1)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_6, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                        class: (0, vue_1.normalizeClass)(_ctx.lastGenerationClass)
                    }, [
                        (0, vue_1.createTextVNode)("of " + (0, vue_1.toDisplayString)(_ctx.lastSoloGeneration), 1)
                    ], 2)), [
                        [_directive_i18n]
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_7, [
            (0, vue_1.createElementVNode)("div", _hoisted_8, [
                (_ctx.messages)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("ul", _hoisted_9, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.messages, (message, index) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_log_message_component, {
                                key: index,
                                message: message,
                                viewModel: _ctx.viewModel,
                                onClick: ($event) => (_ctx.messageClicked(message)),
                                onSpaceClicked: _ctx.spaceClicked
                            }, null, 8, ["message", "viewModel", "onClick", "onSpaceClicked"]));
                        }), 128))
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_10, "(debugid " + (0, vue_1.toDisplayString)(_ctx.step) + ")", 1)
        ]),
        (0, vue_1.createVNode)(_component_card_panel, {
            message: _ctx.selectedMessage,
            players: _ctx.players,
            onHide: _cache[0] || (_cache[0] = ($event) => (_ctx.selectedMessage = undefined))
        }, null, 8, ["message", "players"])
    ]));
}
